import React from 'react';

export default function Button({ children, onClick, color = '#1976d2', textColor = '#fff', style = {}, ...props }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '0.75rem 1.5rem',
        background: color,
        color: textColor,
        border: 'none',
        borderRadius: 8,
        minHeight: 44,
        fontWeight: 600,
        fontSize: 18,
        cursor: 'pointer',
        touchAction: 'manipulation',
        boxShadow: '0 2px 8px #0002',
        transition: 'background 0.2s',
        ...style
      }}
      {...props}
    >
      {children}
    </button>
  );
}
